export const environment = {
  production: false,
  admin: 'https://linkroomv2-admin-dev.web.app',
  api: 'https://admindev-api.linkroom.com',
  transformation_tools: "https://3dtool-api-dev.linkroom.com",
  imagekit: {
    publicKey: 'public_HaXtq7gDdr1WTjhEhsMpoKTpp+8=',
    urlEndpoint: 'https://ik.imagekit.io/b152q4ah5/linkroom-dev'
  }
};
